export const checkGadgetType = (
	webResourceMap: { [key: string]: string },
	gadgetResource?: string,
): boolean => {
	return (
		gadgetResource !== undefined &&
		(gadgetResource in webResourceMap || Object.values(webResourceMap).includes(gadgetResource))
	);
};
